// GENERAL ACTIONS
export const GET_ALL_RATES = 'account_setting/GET_ALL_RATES';
export const SET_ALL_RATES = 'account_setting/SET_ALL_RATES';

// ACTIONS USED TO SWITCH PFE-SKT
export const SWITCH_PFE_SKT_WAITING = 'account_setting/SWITCH_PFE_SKT_WAITING';
export const SWITCH_PFE_SKT = 'account_setting/SWITCH_PFE_SKT';
export const SWITCH_PFE_SKT_MESSAGE = 'account_setting/SWITCH_PFE_SKT_MESSAGE';
export const SWITCH_PFE_SKT_VALUE = 'account_setting/SWITCH_PFE_SKT_VALUE';

// MY PROFILE ACTIONS
export const UPDATE_USERNAME = 'account_setting/UPDATE_USERNAME';
export const UPDATE_PERSONAL_DATA = 'account_setting/UPDATE_PERSONAL_DATA';
export const UPDATE_TIMEZONE = 'account_setting/UPDATE_TIMEZONE';
export const UPDATE_PROFILE_PRIVACY = 'account_setting/UPDATE_PROFILE_PRIVACY';
export const UPDATE_FLASHCARD_ONLY = 'account_setting/UPDATE_FLASHCARD_ONLY';
export const UPLOAD_PROFILE_IMAGE = 'account_setting/UPLOAD_PROFILE_IMAGE';
export const UPDATE_RATE = 'account_setting/UPDATE_RATE';
export const UPDATE_EMAIL = 'account_setting/UPDATE_EMAIL';
export const UPDATE_PASSWORD = 'account_setting/UPDATE_PASSWORD';
export const UPDATE_RATING_EXAM = 'account_setting/UPDATE_RATING_EXAM';
export const LOAD_POSSIBLE_CYCLES_FOR_USER =
  'account_setting/LOAD_POSSIBLE_CYCLES_FOR_USER';
export const POSSIBLE_CYCLES_FOR_UPDATE_EXAM =
  'account_setting/POSSIBLE_CYCLES_FOR_UPDATE_EXAM';

// MY PROFILE STATE SETTERS
export const SET_UPDATE_CYCLE_WAITING =
  'account_setting/SET_UPDATE_CYCLE_WAITING';
export const SET_UPDATE_USERNAME_WAITING =
  'account_setting/SET_UPDATE_USERNAME_WAITING';
export const SET_UPDATE_USERNAME_MESSAGE =
  'account_setting/SET_UPDATE_USERNAME_MESSAGE';
export const SET_UPDATE_PERSONAL_DATA_MESSAGE =
  'account_setting/SET_UPDATE_PERSONAL_DATA_MESSAGE';
export const SET_UPDATE_TIMEZONE_WAITING =
  'account_setting/SET_UPDATE_TIMEZONE_WAITING';
export const SET_UPDATE_TIMEZONE_MESSAGE =
  'account_setting/SET_UPDATE_TIMEZONE_MESSAGE';
export const SET_UPDATE_PROFILE_PRIVACY_WAITING =
  'account_setting/SET_UPDATE_PROFILE_PRIVACY_WAITING';
export const SET_UPDATE_PROFILE_PRIVACY_MESSAGE =
  'account_setting/SET_UPDATE_PROFILE_PRIVACY_MESSAGE';
export const SET_FLASHCARD_ONLY_WAITING =
  'account_setting/SET_FLASHCARD_ONLY_WAITING';
export const SET_FLASHCARD_ONLY = 'account_setting/SET_FLASHCARD_ONLY';
export const SET_FLASHCARD_ONLY_MESSAGE =
  'account_setting/SET_FLASHCARD_ONLY_MESSAGE';
export const UPLOAD_IMAGE_MESSAGE = 'account_setting/UPLOAD_IMAGE_MESSAGE';
export const SET_UPLOADING_IMAGE_WAITING =
  'account_setting/SET_UPLOADING_IMAGE_WAITING';
export const SET_UPLOAD_IMAGE_SUCCES =
  'account_setting/SET_UPLOAD_IMAGE_SUCCES';
export const SET_UPDATE_RATE_WAITING =
  'account_setting/SET_UPDATE_RATE_WAITING';
export const SET_UPDATE_RATE_MESSAGE =
  'account_setting/SET_UPDATE_RATE_MESSAGE';
export const SET_UPDATE_EMAIL_WAITING =
  'account_setting/SET_UPDATE_EMAIL_WAITING';
export const SET_UPDATE_EMAIL_MESSAGE =
  'account_setting/SET_UPDATE_EMAIL_MESSAGE';
export const SET_UPDATE_RATING_EXAM_SUCCESS =
  'account_setting/SET_UPDATE_RATING_EXAM_SUCCESS';
export const SET_UPDATE_RATING_EXAM_WAITING =
  'account_setting/SET_UPDATE_RATING_EXAM_WAITING';
export const SET_UPDATE_RATING_EXAM_MESSAGE =
  'account_setting/SET_UPDATE_RATING_EXAM_MESSAGE';
export const SET_UPDATE_PASSWORD_WAITING =
  'account_setting/SET_UPDATE_PASSWORD_WAITING';
export const SET_UPDATE_PASSWORD_MESSAGE =
  'account_setting/SET_UPDATE_PASSWORD_MESSAGE';
export const SET_POSSIBLE_CYCLES_FOR_USER =
  'account_setting/SET_POSSIBLE_CYCLES_FOR_USER';
export const SET_POSSIBLE_CYCLES_FOR_UPDATE_EXAM =
  'account_setting/SET_POSSIBLE_CYCLES_FOR_UPDATE_EXAM';

// MANAGE SUBSCRIPTION ACTIONS
export const LOAD_USER_SUBSCRIPTION = 'account_setting/GET_USER_SUBSCRIPTION';
export const EDIT_PAYMENT_DETAILS = 'account_setting/EDIT_PAYMENT_DETAILS';

// MANAGE SUBSCRIPTIONS STATE SETTERS
export const SET_USER_SUBSCRIPTION = 'account_setting/SET_USER_SUBSCRIPTION';
export const SET_LOADING_SUBSCRIPTION =
  'account_setting/SET_LOADING_SUBBSCRIPTION';
export const SET_EDIT_PAYMENT_DETAILS_WAITING =
  'account_setting/SET_EDIT_PAYMENT_DETAILS_WAITING';
export const SET_EDIT_PAYMENT_DETAILS_SUCCESS =
  'account_setting/SET_EDIT_PAYMENT_DETAILS_SUCCESS';
export const SET_EDIT_PAYMENT_DETAILS_MESSAGE =
  'account_setting/SET_EDIT_PAYMENT_DETAILS_MESSAGE';

// DISABLED QUESTIONS ACTIONS
export const RESET_ALL_DISABLED_QUESTIONS =
  'account_setting/RESET_ALL_DISABLED_QUESTIONS';
export const GET_DISABLED_QUESTIONS = 'account_setting/GET_DISABLED_QUESTIONS';
export const RESET_DISABLED_INDIVIDUAL_QUESTION =
  'account_setting/RESET_DISABLED_INDIVIDUAL_QUESTION';

// DISABLED QUESTIONS STATE SETTERS
export const IS_LOADING_RESET_ALL_DISABLED_QUESTIONS =
  'account_setting/IS_LOADING_RESET_ALL_DISABLED_QUESTIONS';
export const IS_LOADING_RESET_DISABLED_INDIVIDUAL_QUESTION =
  'account_setting/IS_LOADING_RESET_DISABLED_INDIVIDUAL_QUESTION';
export const IS_LOADING_GET_DISABLED_QUESTIONS =
  'account_setting/IS_LOADING_GET_DISABLED_QUESTIONS';

export const SUCCESS_RESET_ALL_DISABLED_QUESTIONS =
  'account_setting/SUCCESS_RESET_ALL_DISABLED_QUESTIONS';
export const SUCCESS_RESET_DISABLED_INDIVIDUAL_QUESTION =
  'account_setting/SUCCESS_RESET_DISABLED_INDIVIDUAL_QUESTION';
export const SUCCESS_GET_DISABLED_QUESTIONS =
  'account_setting/SUCCESS_GET_DISABLED_QUESTIONS';

export const SET_DISABLED_QUESTIONS = 'account_setting/SET_DISABLED_QUESTIONS';
export const SET_DISABLED_QUESTIONS_COUNT =
  'account_setting/SET_DISABLED_QUESTIONS_COUNT';

// FAVORITE QUESTIONS
export const SET_FAVORITE_QUESTIONS = 'account_setting/SET_FAVORITE_QUESTIONS';
export const SET_ALL_FAVORITE_QUESTIONS =
  'account_setting/SET_All_FAVORITE_QUESTIONS';
export const GET_FAVORITE_QUESTIONS = 'account_setting/GET_FAVORITE_QUESTIONS';
export const GET_ALL_FAVORITE_QUESTIONS =
  'account_setting/GET_ALL_FAVORITE_QUESTIONS';

export const GET_SUBMITTED_QUESTIONS =
  'account_setting/GET_SUBMITTED_QUESTIONS';
export const REMOVE_FAVORITE_QUESTIONS =
  'account_setting/REMOVE_FAVORITE_QUESTIONS';
export const REMOVE_ALL_FAVORITE_QUESTIONS =
  'account_setting/REMOVE_ALL_FAVORITE_QUESTIONS';
export const REMOVE_FAVORITE_QUESTION =
  'account_setting/REMOVE_FAVORITE_QUESTION';

export const LOADING_GET_FAVORITE_QUESTIONS =
  'account_setting/LOADING_GET_FAVORITE_QUESTIONS';
export const LOADING_REMOVE_FAVORITE_QUESTIONS =
  'account_setting/LOADING_REMOVE_FAVORITE_QUESTIONS';
export const SET_FAVORIE_QUESTIONS_COUNT =
  'account_setting/SET_FAVORIE_QUESTIONS_COUNT';

// NOTIFICATION PREFERENCES ACTIONS
export const GET_NOTIFICATION_PREFERENCES =
  'account_setting/GET_NOTIFICATION_PREFERENCES';
export const SEND_NOTIFICATION_PREFERENCES =
  'account_setting/SEND_NOTIFICATION_PREFERENCES';

// NOTIFICATION PREFERENCES STATE SETTERS
export const LOADING_PREFERENCES = 'account_setting/LOADING_PREFERENCES';
export const SUCCESS_PREFERENCES = 'account_setting/SUCCESS_PREFERENCES';
export const ERROR_PREFERENCES = 'account_setting/ERROR_PREFERENCES';
export const SET_NOTIFICATION_PREFERENCES =
  'account_setting/SET_NOTIFICATION_PREFERENCES';
export const SET_SPECIFIC_NOTIFICATION_PREFERENCE =
  'account_setting/SET_SPECIFIC_NOTIFICATION_PREFERENCE';
export const REMOVE_QUESTION_FROM_LIST =
  'account_setting/REMOVE_QUESTION_FROM_LIST';
export const RESET_DISABLED_QUESTIONS_OBJECT =
  'account_setting/RESET_DISABLED_QUESTIONS_OBJECT';
export const RESET_FAVORITE_QUESTIONS_OBJECT =
  'account_setting/RESET_FAVORITE_QUESTIONS_OBJECT';

// ACTIVATE RECEIVE QUESTIONS NOTIFICATIONS FROM COMPLETE FLASH CARD
export const ACTIVATE_RECEIVE_QUESTIONS_NOTIFICATION =
  'account_setting/ACTIVATE_RECEIVE_QUESTIONS_NOTIFICATION';

export const SET_QUESTION_NOTIFICATION =
  'account_setting/SET_QUESTION_NOTIFICATION';

// CUSTOMER SITE MOCK-UP
export const CUSTOMER_SITE = 'account_setting/CUSTOMER_SITE';
export const SET_CUSTOMER_MESSAGE = 'account_setting/SET_CUSTOMER_MESSAGE';
export const SET_CUSTOMER_SITE_MOCK_UP =
  'account_setting/SET_CUSTOMER_SITE_MOCK_UP';
export const GET_CUSTOMER_SITE_MOCK_UP =
  'account_setting/GET_CUSTOMER_SITE_MOCK_UP';
export const LOADING_CUSTOMER_SITE = 'account_setting/LOADING_CUSTOMER_SITE';

// Coupon User
export const APPLY_COUPON_USER = 'account_setting/APPLY_COUPON_USER';
export const GET_LAST_COUPON_USER = 'account_setting/GET_LAST_COUPON_USER';
export const SET_LAST_COUPON_USER = 'account_setting/SET_LAST_COUPON_USER';
export const SET_APPLY_COUPON_MESSAGE =
  'account_setting/SET_APPLY_COUPON_MESSAGE';
export const LOAD_APPLY_COUPON = 'account_setting/LOAD_APPLY_COUPON';

// Submitted questions
export const SET_SUBMITTED_QUESTIONS =
  'account_setting/SET_SUBMITTED_QUESTIONS';
export const SET_LOADING_SUBMITTED_QUESTIONS =
  'account_setting/SET_LOADING_SUBMITTED_QUESTIONS';

// Qual for daily quiz
export const GET_AVAILABLE_QUALS_FOR_DAILY_QUIZ =
  'account_setting/GET_AVAILABLE_QUALS_FOR_DAILY_QUIZ';
export const SET_AVAILABLE_QUALS_FOR_DAILY_QUIZ =
  'account_setting/SET_AVAILABLE_QUALS_FOR_DAILY_QUIZ';

export const SET_FLASH_SECTION_CHOOSE =
  'account_setting/SET_FLASH_SECTION_CHOOSE';
export const SET_STUDY_SPEED_SETTINGS =
  'account_setting/SET_STUDY_SPEED_SETTINGS';
export const SET_STUDY_SPEED_SETTINGS_MESSAGE =
  'account_setting/SET_STUDY_SPEED_SETTINGS_MESSAGE';
export const SET_IS_LOADING_STUDY_SPEED_SETTINGS =
  'account_setting/SET_IS_LOADING_STUDY_SPEED_SETTINGS';

// Custom Sync (mobile app sync settings)
export const GET_CUSTOM_SYNC = 'account_setting/GET_CUSTOM_SYNC';
export const SET_CUSTOM_SYNC = 'account_setting/SET_CUSTOM_SYNC';
export const UPDATE_CUSTOM_SYNC = 'account_setting/UPDATE_CUSTOM_SYNC';
export const SET_CUSTOM_SYNC_MESSAGE =
  'account_setting/SET_CUSTOM_SYNC_MESSAGE';
export const SET_IS_LOADING_CUSTOM_SYNC =
  'account_setting/SET_IS_LOADING_CUSTOM_SYNC';
export const SET_IS_LOADING_CUSTOM_SYNC_DATA =
  'account_setting/SET_IS_LOADING_CUSTOM_SYNC_DATA';
